import { Component, HostListener, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { NgRedux, select } from '@angular-redux/store';
import { Subscription } from 'rxjs';

import { AppState, UserState } from '../../../../interfaces/store.interface';

import { UserActionsService } from '../../../store/actions/user.actions';
// import { WindowRefService } from '../../services/window-ref/window-ref.service';
import { ISellingItemStore } from '../../../../interfaces/SellingItem.interface';
import { map } from 'rxjs/operators';
import { EnvironmentService } from '../../services/environment/environment.service';
import { MenuSizerDirective } from './directives/menu-sizer.directive';
import { MenuItemNode } from '../../../../interfaces/menuItem.interface';
import { ILocalizedString } from '../../../../interfaces/LocalizedString.interface';
import { UserProfile, UserType } from '../../../../interfaces/user.interface';

import { getLocalizedText } from '../../helpers/localization.helper';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [MenuSizerDirective],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnDestroy, OnInit {

  adminUrl: string;
  authUrl: string;

  userProfile: UserProfile;
  userType: any;
  userTypes = UserType;

  userFullName: string;

  isAdmin: boolean;

  unreadMessages: number;

  isShowingDetails: boolean;

  dropdown: string;
  areas$;

  menu: boolean = false;
  infoToggled: boolean = false;

  tenantId: string;

  cmsMenu: MenuItemNode[] = [];
  cmsMenuLocalizedText: string;
  cmsMenuWrapIndex: number;
  cmsMenuWrapIndexFirstChange = false;

  private subscription: Subscription;
  private selectedSubscription: Subscription;
  private messagesSubscription: Subscription;
  private tenantSubscription: Subscription;
  private cmsMenuSubscription: Subscription;
  private cmsMenuWrapIndexSubscription: Subscription;

  constructor(
    private ngRedux: NgRedux<AppState>,
    private userActions: UserActionsService,
    private environmentService: EnvironmentService,
    private changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit() {

    this.adminUrl = this.environmentService.getEnvironment().admin.url;
    this.authUrl = this.environmentService.getEnvironment().oidc.authority;

    this.subscription = this.ngRedux.select<UserState>(['user'])
      .subscribe((userState: UserState) => {

        if (userState.isReady && userState.isLoggedIn && userState.profile) {

          this.userFullName = `${(userState.profile.payload as any).firstName} ${(userState.profile.payload as any).lastName}`;

          this.userProfile = userState.profile.payload;

          this.isAdmin = userState.isAdmin;

          this.userType = userState.identity.payload.profile.user_type;


        } else {

          this.userProfile = null;

        }

      });

    this.selectedSubscription = this.ngRedux.select<ISellingItemStore>(['sales', 'selected'])
      .subscribe((selected: ISellingItemStore) => {
        this.isShowingDetails = !!selected;
      });

    this.messagesSubscription = this.ngRedux.select<number>(['messages', 'unreadMessages'])
      .subscribe((unreadMessages: number) => {
        this.unreadMessages = unreadMessages;
      });

    this.areas$ = this.ngRedux.select(['sellingAreas', 'results', 'payload', 'result']).pipe(
      map((areas: string[]) => {
        const stateAreas: any = this.ngRedux.getState().entities.sellingAreas;
        return areas.map(id => ({
          id,
          name: stateAreas[id].props.name
        }));
      }));

    this.tenantSubscription = this.ngRedux.select<string>(['tenant', 'id'])
      .subscribe((tenantId: string) => {
        if (tenantId) {
          this.tenantId = tenantId.toLowerCase();
        }
      });

    this.cmsMenuSubscription = this.ngRedux.select<MenuItemNode[]>(['cmsMenu', 'menuTree'])
      .subscribe((response) => {
        this.cmsMenu = response || [];
      });

    this.cmsMenuWrapIndexSubscription = this.ngRedux.select<number>(['cmsMenu', 'wrapIndex'])
      .subscribe((response) => {
        this.cmsMenuWrapIndex = response;
        this.changeDetector.detectChanges();
      });

  }

  ngOnDestroy() {

    this.subscription.unsubscribe();
    this.messagesSubscription.unsubscribe();
    this.selectedSubscription.unsubscribe();
    this.tenantSubscription.unsubscribe();
    this.cmsMenuSubscription.unsubscribe();
    this.cmsMenuWrapIndexSubscription.unsubscribe();
  }

  logout(event: Event) {
    event.preventDefault();
    this.userActions.logout();
  }

  setDropdown(event: Event, id: string) {
    event.stopPropagation();
    this.dropdown = id;
  }

  @HostListener('document:click', ['$event'])
  onDocClick(event: Event) {
    if (!this.searchForClassExistance(event.target, 'button-list', 2)) {
      this.dropdown = null;
    }
  }

  toggleMenu() {
    this.menu = !this.menu;
  }
  toggleInfo() {
    this.infoToggled = !this.infoToggled;
  }

  localizeCmsMenuText(menuText: ILocalizedString[]) {
    return getLocalizedText(menuText, this.userProfile.culture);
}

  private searchForClassExistance(element, className, deep) {
    if (deep === 0) {
      return false;
    }
    if (element && (element as any).parentElement) {
      const nextSiblingEl = (element as any).nextElementSibling;
      if (nextSiblingEl && Array.from(nextSiblingEl.classList).includes(className)) {
        return true;
      }
      return this.searchForClassExistance(element.parentElement, className, deep - 1);
    } else {
      return false;
    }
  }

}
